/**
 * @typedef {Object} PreTicket
 * @property {number} code
 * @property {number} value
 * @property {string} date
 * @property {{
 *      game: {
 *          type: number,
 *          name: string
 *      },
 *      value: number,
 *      numbers: string[]
 * }[]} bets
 */

import { dateDiff } from "../loteria/utils/utils";
import { loadState, saveState } from "../modules/localStorage";

/**
 * @returns {PreTicket[]}
 */
export function getFiltredPreTickets() {
    let localpretickets = [];
    if (localStorage && localStorage.getItem("saved-pretickets")) {
        localpretickets = getPreTickets();
        localpretickets.map((savedPreticket, i) => {
            let diff = dateDiff(savedPreticket.bilhetes[0].maxDate) >= 0;
            if (!diff) deletePreTicket(i);
        });
        localpretickets = getPreTickets();
    }
    return localpretickets || [];
}

export function getPreTickets() {
    return JSON.parse((localStorage && localStorage.getItem("saved-pretickets")) || "[]");
}

/**
 * @param {PreTicket[]} newList
 */
export function setPreTickets(newList) {
    if (localStorage) localStorage.setItem("saved-pretickets", JSON.stringify(newList));
}

export function savePreTicket(newPreTicket) {
    const newList = getPreTickets();
    newList.unshift(newPreTicket);
    return setPreTickets(newList);
}

export function clearPreTickets() {
    return setPreTickets([]);
}

export function deletePreTicket(index) {
    const newList = getPreTickets();
    newList.splice(index, 1);
    return setPreTickets(newList);
}

export function hasPreTicketEnabled() {
    const config = window["wweb-session"];
    return config && config.config && !!config.config.bitVendePreTicket;
}

export function hasPreTicketParam() {
    const params = new URLSearchParams(window.location.search);
    let hasPreTicket = params.get("preticket");
    return hasPreTicket === "true" && hasPreTicketEnabled();
}

export function hasPreTicketConfig() {
    const config = window["wweb-session"];
    return config && config.config && config.config.bitVendePreTicket;
}

export function hasPixParam() {
    const params = new URLSearchParams(window.location.search);
    let hasPix = params.get("pix");
    return hasPix === "true";
}

export function hasWrapper() {
    const params = new URLSearchParams(window.location.search);
    let wrapper = params.get("hasWrapper");
    return wrapper === "true";
}

export function isBLP() {
    const params = new URLSearchParams(window.location.search);
    let isBLP = params.get("isBLP");
    return isBLP === "true";
}

export function disableSuperTime() {
    const params = new URLSearchParams(window.location.search);
    return !!params.get("disableSuperTime");
}

export function hasWalletEnabled() {
    const config = window["wweb-session"];
    return config && config.config && !!config.config.bitUsaWallet;
}

export function hasWalletParam() {
    const params = new URLSearchParams(window.location.search);
    let hasPix = params.get("pix");
    let hasPreTicket = params.get("preticket");
    let hasWallet = params.get("wallet");
    return (hasWallet === "true" && hasWalletEnabled()) || (!hasPix && !hasPreTicket && !hasWallet);
}

export function getUser() {
    const params = new URLSearchParams(window.location.search);
    const user = params.get("userId") != undefined ? params.get("userId") : (loadState("user") || {}).user_id || "";
    saveState(user, "user");

    return user;
}

export function getPhone() {
    const params = new URLSearchParams(window.location.search);
    const phone = params.get("phone") != undefined ? params.get("phone") : "";
    saveState(phone, "phone");

    return phone;
}

export function getName() {
    const params = new URLSearchParams(window.location.search);
    const name = params.get("name") != undefined ? params.get("name") : "";
    saveState(name, "name");

    return name;
}


export function hasLogin() {
    const params = new URLSearchParams(window.location.search);
    let bitLogin = params.get("bitLogin");
    const user = getUser();

    const returnedValue = !!(bitLogin === "false" || (bitLogin === "true" && user.length > 0));
    return returnedValue;
}

export function hasBitLogin() {
    const params = new URLSearchParams(window.location.search);
    let bitLogin = params.get("bitLogin");
    return bitLogin === "true";
}


// WEBPACK FOOTER //
// ./src/utils/getPreTickets.js